export const generativeAiAgents = "/generative_ai/agents";
